import React from 'react';
import { Quote } from 'lucide-react';
import { AnimatedSection } from './ui/AnimatedSection';
const testimonials = [{
  initials: 'JM',
  location: 'Rosario',
  type: 'Delivery',
  quote: 'Diagnostiqué el rulemán dañado yo solo con el Tomo 3 y lo cambié en un sábado. Ahorré $80.000 ARS en service.'
}, {
  initials: 'VR',
  location: 'CABA',
  type: 'Commuter diaria',
  quote: 'Cambié los sensores Hall yo sola siguiendo el paso a paso. Nunca más dependo del service para lo básico.'
}, {
  initials: 'FS',
  location: 'Córdoba',
  type: 'Rider de performance',
  quote: 'Después del Configuración PRO, mi Begode aguanta rodadas de verano que antes cortaban a los 30 minutos.'
}];
export function Testimonials() {
  return <AnimatedSection className="py-12 bg-brand-surface border-y border-brand-border" data-id="element-246">
      <div className="container mx-auto px-4 md:px-6" data-id="element-247">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-248">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-brand-dark p-6 rounded-lg border border-brand-border relative overflow-hidden group hover:border-brand-yellow/50 transition-colors" data-id="element-249">
              <Quote className="absolute top-4 right-4 w-12 h-12 text-zinc-800 group-hover:text-zinc-700 transition-colors" data-id="element-250" />
              <div className="relative z-10" data-id="element-251">
                <p className="text-zinc-300 mb-6 italic" data-id="element-252">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-3" data-id="element-253">
                  <div className="w-10 h-10 rounded-full bg-brand-yellow/10 flex items-center justify-center text-brand-yellow font-heading font-bold" data-id="element-254">
                    {testimonial.initials}
                  </div>
                  <div data-id="element-255">
                    <div className="font-bold text-white" data-id="element-256">
                      {testimonial.location}
                    </div>
                    <div className="text-xs text-brand-yellow uppercase tracking-wider" data-id="element-257">
                      {testimonial.type}
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </AnimatedSection>;
}